<template>
  <v-dialog v-model="dialog" content-class="v-dialog--custom"
    :fullscreen="$vuetify.breakpoint.xsOnly">
    <v-card>
      <v-card-title class="headline">Delete Confirmation</v-card-title>
      <v-card-text>
        <v-container>
          <alert-message />
          Are you sure will delete client "{{ name }}"?
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="closeDelete">Cancel</v-btn>
        <v-btn class="error" text @click="deleteItemConfirm" :loading="loading"
          >Delete
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
import UTIL from "src/helpers/utility";
import AlertMessage from "src/components/AlertMessage";

export default {
  props: {
    item: Object,
    show: [Boolean, String],
  },
  components: {
    AlertMessage
  },
  data() {
    return {
      dialog: false,
      loading: false,
    };
  },
  computed: {
    ...mapState({
      client: (state) => state.client,
      alert: (state) => state.alert,
    }),

    name() {
      return UTIL.gv(this.item, 'companyName');
    }
  },
  watch: {
    show(n, o) {
      if (n && !o) {
        this.dialog = true;
      }
    },
  },
  methods: {
    ...mapActions("client", ["delete"]),
    closeDelete() {
      this.dialog = false;
      this.$store.dispatch('alert/clear');
      this.$emit("onClosed");
    },
    async deleteItemConfirm() {
      this.loading = true;
      await this.delete(this.item);
      if (!this.client.status.error) {
        this.closeDelete();
        this.$emit("onSucceded");
      }
      this.loading = false;
    },
  },
};
</script>